/**
 * 葡萄牙语（pt）
 */

import ptLocale from 'element-ui/lib/locale/lang/pt'

export default {
  ...ptLocale,
  currency: {
    product: 'Produto',
    inStock: 'Em stock',
    myProduct: 'O Meu Produto',
    listings: 'Listagens',
    wishList: 'Lista de Desejos',
    allOrder: 'Toda a Ordem',
    store: 'Armazenar',
    personalCenter: 'Centro Pessoal',
    payment: 'Pagamento',
    address: 'Endereço',
    accountSettings: 'Configuração da Conta',
    logOut: 'Sair',
    selectAll: 'Seleccionar Tudo',
    confirmOrder: 'Confirmar ordem',
    back: 'Voltar',
    home: 'Casa',
    newIn: 'Novo In',
    deleteTip: 'Você tem certeza de excluir o produto selecionado?',
    delete: 'apagar'
  },
  // 语言
  lang: {
    english: 'Inglés',
    chinese: 'Chinês',
    spanish: 'Español',
    japanese: 'Japonés',
    portuguese: 'Portugués',
    french: 'Francés',
    russian: 'Ruso',
    arabic: 'árabe',
    german: 'Alemán',
    italian: 'Italiano',
    vietnam: 'Viet Nam',
    turkey: 'Turquía',
    korean: 'Coreano',
    thai: 'Tailandés',
    dutch: 'Holandés',
    hebrew: 'Hebreo',
    indonesian: 'Indonesio'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {
    category: 'Categoria',
    search: 'procurar',
    searchingFor: 'Separe várias pesquisas com vírgulas ou espaços',
    shippingFrom: 'Envio de',
    fabric: 'Tecido',
    price: 'Preço',
    inventory: 'Inventário',
    newest: 'O mais novo',
    sales: 'Vendas',
    min: 'Min',
    max: 'Máx',
    recentSearches: 'Pesquisas Recentes',
    hotSearches: 'Pesquisas Quentes'
  },
  // 商品详情页
  productDetail: {
    product: 'Produto',
    detail: 'detalhe',
    itemNo: 'item n.o',
    processingTime: 'Tempo de processamento',
    shippingCost: 'Custo de envio',
    paymentMethod: 'Método de pagamento',
    sizeGuide: 'Guia de Tamanho',
    color: 'cor',
    size: 'Tamanho',
    viewAllVariants: 'Ver Todos os Variantes',
    allVariants: 'Todos os Variantes',
    shipFrom: 'Navio de',
    addToCart: 'Adicionar ao Cart',
    listToStore: 'Lista a armazenar',
    addToWishList: 'Adicionar à Lista de Desejos',
    description: 'Descrição',
    return: 'Retornar',
    refundPolicy: 'Política de reembolso',
    shipping: 'Envio',
    image: 'Imagem',
    action: 'Acção',
    // 选项卡/shipping
    packingSize: 'Tamanho da embalagem',
    packingWeight: 'Peso de embalagem',
    shippingFrom: 'Envio de',
    shippingTo: 'Envio para',
    qty: 'Qty.',
    maximum: 'Inventário máximo:',
    shippingMethod: 'Método de expedição',
    estimatedDeliveryTime: 'Tempo estimado de entrega',
    sizeChart: 'Tabela de Tamanhos',
    deliveryTime: 'Prazo de entrega',
    outOfStockTips: 'Desculpe, acabou-se o stock!'
  },
  // 购物车
  shoppingCart: {
    shoppingCart: 'Cart ão de compras',
    topTip: 'Selecione produtos no mesmo armazém para colocar uma ordem.'
  },
  // 确认订单
  confirmOrder: {
    shippingAddress: 'Endereço de Envio',
    addNewAddress: 'Adicionar um Novo Endereço',
    selectAnotherAddress: 'Selecione outro endereço',
    editTheAddress: 'Editar o endereço',
    remark: 'Observação',
    unitPrice: 'Preço unitário',
    totalPayable: 'Total pagável',
    itemSubtotal: 'Subtotal do Item',
    subtotal: 'Subtotal',
    shippingSubtotal: 'Subtotal de envio',
    promotion: 'Promoção',
    grandTotal: 'Total geral',
    creditCard: 'Cartão de crédito',
    balance: 'Saldo',
    payNow: 'Pague agora.',
    commonProblem: 'Problema Comum',
    emailVerification: 'Verificação por e-mail',
    verificationTitle: 'Um código de verificação foi enviado para o seu e-mail',
    verification: 'Verificação',
    seconds: 'segundos',
    laterGetPasswordAgain: 'mais tarde obter senha novamente',
    sendAgain: 'enviar novamente'
  },
  // 账号设置弹窗
  setting: {
    setting: 'Configuração',
    fullName: 'Nome completo',
    email: 'Email',
    password: 'Senha',
    confirmPassword: 'Confirmar senha',
    notVerified: 'Não verificado',
    change: 'Variação',
    codeSend: 'Um código de verificação foi enviado para o seu e-mail'
  }
  // 张丰

  // 孙泽严
}
